import React, { useState, useRef, useEffect } from "react";
import "./EditNoteGroup.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import { normalizeColor } from "../../../../utils/colors";
import ColorPicker from "../../../../components/ColorPicker/ColorPicker";

function EditNoteGroup({
  noteGroupData,
  updateNoteGroup,
  cancelEditNoteGroup,
}) {
  const [name, setName] = useState(noteGroupData?.name || "");
  const [selectedColor, setSelectedColor] = useState(
    normalizeColor(noteGroupData?.color)
  );
  const [showNameError, setShowNameError] = useState(false);

  // Update state when noteGroupData changes
  useEffect(() => {
    if (noteGroupData) {
      setName(noteGroupData.name || "");
      setSelectedColor(normalizeColor(noteGroupData.color));
    }
  }, [noteGroupData]);

  const handleUpdateNoteGroup = () => {
    if (name.trim()) {
      const colorHex = normalizeColor(selectedColor);
      updateNoteGroup(noteGroupData._id, name.trim(), colorHex);
      setShowNameError(false);
    } else {
      setShowNameError(true);
    }
  };

  // Set focus on input field when modal opens
  const inputRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        inputRef.current.select(); // Select all text for easy editing
      }
    }, 100); // 100ms delay to ensure DOM is ready
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="edit-note-group-content">
      <div className="modal-title">
        <div>Edit Note Group</div>
      </div>
      <div className="modal-form">
        <div className="modal-form-title">Name</div>
        <input
          ref={inputRef}
          type="text"
          className="modal-text-input"
          placeholder="Note Group Name"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (showNameError && e.target.value.trim()) {
              setShowNameError(false);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleUpdateNoteGroup();
            }
          }}
        />
        {showNameError && (
          <div className="modal-helper-text">Please enter a group name</div>
        )}

        <div className="modal-form-title">Color</div>
        <div className="color-picker-wrapper">
          <ColorPicker
            selectedColor={selectedColor}
            onColorSelect={setSelectedColor}
          />
        </div>
        <div className="modal-form-buttons">
          <button
            className="modal-button cancel"
            onClick={() => {
              cancelEditNoteGroup();
            }}
          >
            Cancel
          </button>
          <button className="modal-button save" onClick={handleUpdateNoteGroup}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditNoteGroup;
